"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
class Query {
}
exports.Query = Query;
//# sourceMappingURL=Query.js.map